/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const integrationCustomFieldMappingCreateRequestSchema = z.object({
  instanceFieldMappingId: z.int(),
  syncDirection: z.enum(['PULL_ONLY', 'PUSH_ONLY', 'BIDIRECTIONAL']),
});
